import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Linkedin, ArrowUp, Mail, Phone } from 'lucide-react';

const FooterLink = ({ to, children }) => (
  <Link
    to={to}
    className="block text-white/70 hover:text-[#e8c887] text-[14.5px] py-1 transition-colors"
  >
    {children}
  </Link>
);

const Footer = () => {
  return (
    <footer className="relative">
      <div className="hairline-gold" />
      <div className="navy-panel text-white">
        <div className="max-w-[1240px] mx-auto px-4 lg:px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Column 1 – About + Contact */}
          <div>
            <h3 className="font-heading text-2xl font-bold mb-4 text-white">Finirio</h3>
            <p className="text-white/60 text-[14px] leading-relaxed mb-5">
              India's trusted home loan partner. Compare offers from 40+ banks &amp; NBFCs and get the best rate — stress-free.
            </p>
            <div className="space-y-2.5">
              <a
                href="tel:+917972467340"
                className="flex items-center gap-2.5 text-white/80 hover:text-[#e8c887] text-[14px] transition-colors"
              >
                <span className="w-8 h-8 rounded-full grid place-items-center bg-white/10 border border-white/10 flex-none">
                  <Phone className="w-3.5 h-3.5" />
                </span>
                +91 79724 67340
              </a>
              <a
                href="mailto:sales@finirio.com"
                className="flex items-center gap-2.5 text-white/80 hover:text-[#e8c887] text-[14px] transition-colors"
              >
                <span className="w-8 h-8 rounded-full grid place-items-center bg-white/10 border border-white/10 flex-none">
                  <Mail className="w-3.5 h-3.5" />
                </span>
                sales@finirio.com
              </a>
            </div>
          </div>

          {/* Column 2 – Loan Products */}
          <div>
            <h3 className="text-[13px] font-bold mb-5 uppercase tracking-[.2em] text-[#e8c887]">Loan Products</h3>
            <div className="space-y-0.5">
              <FooterLink to="/home-loan">Home Loan</FooterLink>
              <FooterLink to="/loan-against-property">Loan Against Property</FooterLink>
              <FooterLink to="/business-loan">Business Loan</FooterLink>
              <FooterLink to="/personal-loan">Personal Loan</FooterLink>
              <FooterLink to="/working-capital">OD / CC (Working Capital)</FooterLink>
              <FooterLink to="/documents">Documents Required</FooterLink>
            </div>
          </div>

          {/* Column 3 – Tools & Company */}
          <div>
            <h3 className="text-[13px] font-bold mb-5 uppercase tracking-[.2em] text-[#e8c887]">Tools &amp; Company</h3>
            <div className="space-y-0.5">
              <FooterLink to="/emi-calculator">EMI Calculator</FooterLink>
              <FooterLink to="/eligibility-calculator">Eligibility Calculator</FooterLink>
              <FooterLink to="/loan-comparison">Loan Comparison</FooterLink>
              <FooterLink to="/charges-calculator">Charges Calculator</FooterLink>
              <FooterLink to="/about-us">About Us</FooterLink>
              <FooterLink to="/careers">Careers</FooterLink>
              <FooterLink to="/become-partner">Become a Partner</FooterLink>
            </div>
          </div>

          {/* Column 4 – Social */}
          <div>
            <h3 className="text-[13px] font-bold mb-5 uppercase tracking-[.2em] text-[#e8c887]">Follow Us</h3>
            <div className="space-y-2 mb-6">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#e8c887] text-[14.5px] transition-colors">
                <Facebook className="w-4 h-4" /> Facebook
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#e8c887] text-[14.5px] transition-colors">
                <Instagram className="w-4 h-4" /> Instagram
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#e8c887] text-[14.5px] transition-colors">
                <Twitter className="w-4 h-4" /> Twitter / X
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#e8c887] text-[14.5px] transition-colors">
                <Youtube className="w-4 h-4" /> YouTube
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#e8c887] text-[14.5px] transition-colors">
                <Linkedin className="w-4 h-4" /> LinkedIn
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-[#081c35] border-t border-white/10">
        <div className="max-w-[1240px] mx-auto px-4 lg:px-6 py-5 flex items-center justify-between text-white/50 text-sm flex-wrap gap-2">
          <p>
            Copyright &copy; {new Date().getFullYear()} Finirio Financial Services. All rights reserved. &nbsp;|&nbsp;{' '}
            <Link to="/privacy" className="hover:text-[#e8c887] transition-colors">Privacy Policy</Link>
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-9 h-9 grid place-items-center rounded-full bg-white/10 hover:bg-[#c9a24b] hover:text-[#0b2545] text-white transition-colors"
            aria-label="Scroll to top"
          >
            <ArrowUp className="w-4 h-4" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
